module.exports = __webpack_public_path__ + "assets/img/d0281ffc5c3b2e99b23d75407265da28.svg";